import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Send, FileCheck2, Loader2 } from "lucide-react";
import { downloadSignedContract } from "@/components/ContractPanel";
import { RejectContractDialog } from "@/components/RejectContractDialog";
import { ContractHistoryDialog } from "@/components/ContractHistoryDialog";

const LABELS = {
  sent: ["أُرسل — بانتظار التوقيع", "bg-amber-500/10 text-amber-700 border-amber-500/30"],
  uploaded: ["العقد الموقع مرفوع", "bg-emerald-500/10 text-emerald-700 border-emerald-500/30"],
  rejected: ["العقد مرفوض — بانتظار إعادة الرفع", "bg-destructive/10 text-destructive border-destructive/30"],
};

export function ProviderContractCell({ user, onChanged }) {
  const [busy, setBusy] = useState(false);
  const c = user.contract || {};
  if (user.status === "active" && !c.status) return <span className="text-xs text-muted-foreground">—</span>;
  const hasFile = Boolean(c.file_id);

  const send = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/users/${user.id}/send-contract`);
      toast.success(`تم إرسال العقد إلى ${user.email}`);
      onChanged();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setBusy(false);
  };
  const view = () => downloadSignedContract(c.file_id, user.name).catch(() => toast.error("تعذّر تحميل العقد"));

  return (
    <div className="flex flex-col gap-1.5 items-start" data-testid={`contract-cell-${user.id}`}>
      {LABELS[c.status] && <Badge variant="outline" className={LABELS[c.status][1]}>{LABELS[c.status][0]}</Badge>}
      {c.status === "rejected" && c.rejection_note && <div className="text-xs text-muted-foreground max-w-[220px] truncate" title={c.rejection_note} data-testid={`contract-note-${user.id}`}>{c.rejection_note}</div>}
      <div className="flex flex-wrap gap-1.5">
        {user.status !== "active" && (
          <Button size="sm" variant="outline" className="h-8 rounded-lg gap-1" disabled={busy} onClick={send} data-testid={`send-contract-${user.id}`}>
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />} {c.sent_at ? "إعادة الإرسال" : "إرسال العقد"}
          </Button>
        )}
        {c.status === "uploaded" && (
          <Button size="sm" variant="outline" className="h-8 rounded-lg gap-1 text-emerald-700" onClick={view} data-testid={`view-contract-${user.id}`}>
            <FileCheck2 className="w-3.5 h-3.5" /> عرض العقد
          </Button>
        )}
        {c.status === "uploaded" && user.status !== "active" && <RejectContractDialog user={user} onDone={onChanged} />}
        {hasFile && <ContractHistoryDialog user={user} />}
      </div>
    </div>
  );
}
